import { Theme, FAIcon, useTranslation } from '@nextgen-web-framework/all';
import styles from './OtpVerifiedLabel.module.scss';

const OtpVerifiedLabel = () => {
  const t = useTranslation();
  return (
    <div data-testid="otp-verified-test-id" className={styles['identity-otp-verified-label']}>
      <span className={styles['icon']}>
        <FAIcon theme={Theme.SUCCESS} iconName="shield-check" />
      </span>
      <span className={styles['title']}>{t('identity.VerifyOtp.verified')}</span>
    </div>
  );
};

export default OtpVerifiedLabel;
